import { Constants } from '@firmable/utilities';
import axios from 'axios';

// Web client-source is a constant and unrelated to auth. Set it as an axios
// default at module load (this file is imported for its side effect in _app),
// so every our-API request carries it — including unauthenticated ones that
// fire before the auth interceptor attaches.
axios.defaults.headers.common[Constants.ClientSource.HEADER] = 'app';
